import { render, staticRenderFns } from "./newEnvForm.vue?vue&type=template&id=65e75486&"
import script from "./newEnvForm.vue?vue&type=script&lang=ts&"
export * from "./newEnvForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports